export default __webpack_public_path__ + "static/media/pointIcon.5b229e99.svg";